import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import styles from './ColorSwatch.module.scss';
export function ColorSwatch({ options, onChange, selectType = 'multiple', }) {
    const [optimisticOptions, setOptimisticOptions] = useState(options);
    // Update optimistic options when props change (API response)
    useEffect(() => {
        setOptimisticOptions(options);
    }, [options]);
    const normalizeColorName = (colorName) => {
        return colorName.toLowerCase().replace(/\s+/g, '-');
    };
    const getSwatchData = (colorName) => {
        var _a;
        const swatchMap = ((_a = window.plpConfig) === null || _a === void 0 ? void 0 : _a.swatchIconMap) || [];
        const normalizedName = normalizeColorName(colorName);
        const swatchItem = swatchMap.find((item) => item.colour_handle === normalizedName);
        if (!swatchItem)
            return {};
        return {
            image: swatchItem.swatch_image || undefined,
            color: swatchItem.colour_code || undefined,
        };
    };
    const handleSwatchClick = (optionId) => {
        // Optimistically update the UI immediately
        setOptimisticOptions(prevOptions => prevOptions.map(option => {
            if (option.id === optionId) {
                return Object.assign(Object.assign({}, option), { selected: !option.selected });
            }
            return option;
        }));
        // Call the actual onChange handler
        onChange(optionId);
    };
    return (h("div", { className: styles.colorSwatchList }, optimisticOptions.map((option) => {
        const { image, color } = getSwatchData(option.label);
        return (h("button", { key: option.id, className: `${styles.colorSwatch} ${option.selected ? styles.selected : ''}`, style: {
                backgroundImage: image ? `url(${image})` : undefined,
                backgroundColor: color || '#dfdfdf',
                backgroundSize: image ? 'cover' : undefined,
                backgroundPosition: image ? 'center' : undefined,
                backgroundRepeat: image ? 'no-repeat' : undefined,
            }, onClick: () => handleSwatchClick(option.id), title: option.label }));
    })));
}
